import gql from 'graphql-tag';

export default {
  getRedirectsActive: gql`
    query getRedirectsActive {
      getRedirectsActive {
        id
        uri_from
        uri_to
        is_not_found
      }
    }
  `
};
